module.exports = __webpack_public_path__ + "images/b03fefc26b468962aa06350abd5d1616.svg";